/**
 * RequestDetail Page
 *
 * Page wrapper for Request Detail View.
 *
 * @module pages/feedback/RequestDetail
 */

import React from 'react';
import { Box, Container } from '@mui/material';
import RequestDetailView from '../../components/feedback/RequestDetailView';

/**
 * RequestDetail Page
 */
const RequestDetail: React.FC = () => {
  return (
    <Container maxWidth="xl">
      <Box py={4}>
        <RequestDetailView />
      </Box>
    </Container>
  );
};

export default RequestDetail;
